import React from 'react'
import { withRouter } from "react-router-dom";

const DataTableRow = withRouter(({rowData, column, editRoute, history}) => {

    const goToEditRoute = (id) => {
        history.push(editRoute + id)
    }

    return (
        <td onClick={() => goToEditRoute(rowData.id)}
            dangerouslySetInnerHTML={{ __html: 
                'transform' in column
                    ? column.transform(rowData[column.key])
                    : rowData[column.key] 
            }}
        />
    )
})

export default DataTableRow


// WEBPACK FOOTER //
// ./src/components/utils/DataTable/DataTableRow.js